<template>
  <section class="isolations">
    <h2 class="wizard__title">
      <span>{{ $t('message.constructionParams.isolation.title') }}</span>
    </h2>
    <div class="isolations__wrapper">
      <RadioButton
        v-for="system in isolationTypes"
        :key="system.id"
        :selected="currentIsolation"
        :radioGroup="system"
        :label="system.name"
        @input="update($event, 'isolationType')"
      />
    </div>
  </section>
</template>

<script>
import { initialVisibleItems } from '@/utils/utils'
import { mapGetters } from 'vuex'
import RadioButton from '@/components/dump/RadioButton.vue'

export default {
  name: 'IsolationMaterials',
  components: { RadioButton },
  data: () => ({
    initialVisibleItems: initialVisibleItems,
    limit: initialVisibleItems,
    allShowed: false,
    currentIsolation: null
  }),
  mounted() {
    this.update({ newValue: this.getIsolationTypes[0].value })
  },
  computed: {
    ...mapGetters({
      getIsolationTypes: 'getIsolationTypes'
    }),
    isolationTypes() {
      if (this.getIsolationTypes.length === 0) return this.getIsolationTypes
      return this.getIsolationTypes.map((type) => {
        return {
          id: type.id,
          constructionId: type.id,
          img: this.images[type.name],
          value: type.value,
          name: this.$t(`message.constructionParams.isolation.categories.${type.name}`)
        }
      })
    },
    images() {
      return {
        fiberglass: require('@/assets/img/fiberglass.png'),
        stonewall: require('@/assets/img/stonewall.png')
      }
    }
  },
  methods: {
    update(evt) {
      this.currentIsolation = evt.newValue
      this.$store.commit('UPDATE_ISOLATION_MATERIALS', evt.newValue)
    }
  }
}
</script>

<style lang="sass">
.isolations
  width: 100%
  overflow: hidden
  overflow-y: auto
  padding-right: rem(5)
  padding-bottom: rem(40)
  &__wrapper
    display: grid
    grid-gap: rem(20)
    width: 100%
    grid-template-rows: auto
    +media((grid-template-columns: (0: 1fr, 580: repeat(2, 1fr), 1070: repeat(2, 1fr))))
</style>
